export default __webpack_public_path__ + "static/media/logo.02f7e22a.svg";